import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

// 路由级 Suspense fallback：内容区域内居中的加载态，
// 适配带布局（侧边栏/头部）的 Outlet 以及无布局的顶层路由
const PageLoading = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Spin size="large" style={{ padding: '28px' }} />
      <div style={{ fontSize: '1.1rem' }}>{t('pages.loading.loadingResources')}</div>
      <div style={{ marginTop: '20px', fontSize: '1rem', color: '#888' }}>
        {t('pages.loading.initialLoadMessage')}
      </div>
    </div>
  );
};

export default PageLoading;
